import React from 'react'
import { NotificationEngineScreen } from '@src/types'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useLiveNotificationBanner } from '../hooks/useLiveNotificationBanner'
import { BaseLiveSurfaceBannerBody } from './BaseLiveSurfaceBannerBody'

export const InboxBanner = () => {
  const styles = useStyleSheet(themedStyles)
  const bannerProps = useLiveNotificationBanner({ screen: NotificationEngineScreen.Inbox })

  if (!bannerProps) {
    return null
  }

  return (
    <BaseLiveSurfaceBannerBody
      {...bannerProps}
      style={styles.bannerStyle}
      testIdPrefix="NotificationInbox/Banner"
    />
  )
}

const themedStyles = StyleService.create({
  bannerStyle: {
    marginBottom: 16,
  },
})
